.show_table {
	margin-bottom: 16px;

	.table {
		width: 100%;
		border-collapse: collapse;
		font-size: 14px;

		td {
			padding: 8px 4px;
		}

		.first_td {
			font-weight: bold;
			text-align: left;
		}

		.last_td {
			text-align: right;
		}
	}
}

.graph_filter {
	width: 100%;
	height: 300px;
}
